export default __webpack_public_path__ + "static/media/16.647184ca.gif";